import { navigateTo } from '../actions/navigateTo';
import { libraryPageTitle } from '../../i18n/translations';
import { setToolbarTitle } from '../../store/to-native';

const handlerName = 'Navigate';

function handler(payload, store) {
  const { entryPoint, clearBackStack } = payload;

  if (entryPoint === '') {
    setToolbarTitle(libraryPageTitle());
  }

  navigateTo(entryPoint, store, clearBackStack);
}

export { handlerName, handler };
